export const orderingTimesQuery = gql`
     query orderingTimes($dispatchType: DispatchType!, $date: Date) {
        orderingTimes(dispatchType: $dispatchType, date: $date) {
            times
        }
    }
`
